export const PHRASES = {
  CODE_COPIED: $localize`:@@bets.create_auto_bet.code_copied:Код скопирован!`,
  PRESET_IMPORTED: $localize`:@@bets.create_auto_bet.success_import:Автоставка импортирована`,
  PRESET_CREATED: $localize`:@@bets.create_auto_bet.bet_created:Автоставка создана`,
  PRESET_UPDATED: $localize`:@@bets.create_auto_bet.bet_updated:Автоставка обновлена`
};